// @flow

import {
  createUnauthenticatedHttpClient,
  withRequestId
} from 'src/modules/seek-api-request';
import includes from 'lodash/includes';
import get from 'lodash/get';
import keys from 'lodash/keys';

type AllowedMethod = 'GET' | 'POST';

type HttpClientHandler = (
  requestId: ?string
) => (method: AllowedMethod, url: string) => Promise<any>;

let activeExperiments: Array<string> = [];

const chaliceExperimentFilter = key => includes(activeExperiments, key);

export const setActiveExperiments = (experimentIds: Array<string>) => {
  activeExperiments = experimentIds;
};

export const formatExperiments = (
  reducer: Function,
  experiments: any
): Array<any> =>
  keys(experiments)
    .filter(chaliceExperimentFilter) // Exclude experiments from other projects
    .map(key => get(experiments, key))
    .reduce(reducer, []);

const CLIENT_TIMEOUT = 500 * 2; // 95% of requests are served in < 500ms on the client side, allow tolerance of double this.
const SERVER_TIMEOUT = 50 * 2; // 95% of requests are served in < 50ms on the server side, allow tolerance of double this.
const EXPERIMENTS_TIMEOUT = ENV.SERVER ? SERVER_TIMEOUT : CLIENT_TIMEOUT;

const httpClient: HttpClientHandler = requestId => (
  method: string,
  url: string
) =>
  createUnauthenticatedHttpClient()
    .send({
      url,
      method: method.toUpperCase() === 'GET' ? 'get' : 'post',
      timeout: EXPERIMENTS_TIMEOUT,
      label: 'experiments',
      headers: withRequestId(requestId)
    })
    .then(({ data }) => data)
    .catch(() => {
      // swallow error, details will be captured with http metric & logging middleware
    });

export default httpClient;
